import { createReducer, createAction } from '@reduxjs/toolkit'

export interface LessonToolsReducer {
  microphoneEnabled: boolean
  cameraEnabled: boolean
  speakerEnabled: boolean
}

const initialState: LessonToolsReducer = {
  microphoneEnabled: true,
  cameraEnabled: true,
  speakerEnabled: true
}

export const TOGGLE_MICROPHONE = createAction('lesson_tools_reducer/toggle_microphone')
export const TOGGLE_CAMERA = createAction('lesson_tools_reducer/toggle_camera')
export const TOGGLE_SPEAKER = createAction('lesson_tools_reducer/toggle_speaker')

export const lessonToolsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(TOGGLE_MICROPHONE, (state) => {
      return { ...state, microphoneEnabled: !state.microphoneEnabled }
    })
    .addCase(TOGGLE_CAMERA, (state) => {
      return { ...state, cameraEnabled: !state.cameraEnabled }
    })
    .addCase(TOGGLE_SPEAKER, (state) => {
      return { ...state, speakerEnabled: !state.speakerEnabled }
    })
})
